<template>
  <div class="login">
    <form action="">
      <el-input
        class="mt5"
        placeholder="请输入用户名"
        v-model="username"
      ></el-input>
      <el-input
        class="mt5"
        type="password"
        placeholder="请输入密码"
        v-model="password"
        @keyup.enter.native="login"
      ></el-input>
      <el-button class="login-button mt5" @click="login">登录</el-button>
    </form>
  </div>
</template>

<script>
import { setAuthHeader } from "@/axios";
import { OopsErrorELMessage } from "@/mixins";
export default {
  name: "Login",
  mixins: [OopsErrorELMessage],
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    login() {
      delete this.$http.defaults.headers.common.Authorization;
      this.$http
        .post("/api/v1/auth/jwt/login", {
          username: this.username,
          password: this.password
        })
        .then(resp => {
          window.localStorage.setItem("token", resp.data.token);
          setAuthHeader(resp.data.token);
          this.$router.push({ name: "admin" });
        })
        .catch(() => {
          this.oopsError("登录失败");
          this.username = "";
          this.password = "";
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles-variables.scss";
.mt5 {
  margin-top: 5px;
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url(https://picsum.photos/400/300/?random&blur);
  background-size: cover;
}
form {
  width: 400px;
  & .login-button {
    font-size: 1.2rem;
    color: white;
    width: 100%;
    background-color: $main-blue;
    border: none;

    &:hover {
      background-color: #558fd8;
    }
  }
}
</style>
